<template>
    <section class="home-container">
        <MasterPage title="文章管理">
            <div slot="title-icon">
                <Icon type="ios-paper" />
            </div>
            <div slot="searchContent" class="search-content-slot">
                <Form :label-width="80">
                    <Row>
                        <Col span="12">
                        <FormItem label="文章标题：">
                            <Input v-model="title" placeholder="请输入" />
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="文章状态：">
                            <Select v-model="statusList" @on-change="pageNum = 1" placeholder="请选择">
                                <Option value="0">未发布</Option>
                                <Option value="1" >已发布</Option>
                                <Option value="2" >已撤回</Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="文章类别：">
                            <Select v-model="category" @on-change="pageNum = 1" placeholder="请选择" filterable clearable >
                                <Option v-for="item in articleTypeList" :value="item.id" :key="item.id">
                                    {{ item.name }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="创建时间：">
                            <DatePicker v-model="createTime" style="width: 100%" type="daterange" placement="bottom-end" placeholder="请选择文章创建时间"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="创建账户：">
                            <Select v-model="createUser" clearable placeholder="请选择">
                                <Option v-for="item in systemUserAllList" :value="item.loginName" :key="item.loginName">
                                    {{ item.loginName + "（" + item.realName + "）" }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="发布时间：">
                            <DatePicker v-model="releaseTime" style="width: 100%" format="yyyy/MM/dd" type="daterange" placement="bottom-end" placeholder="请选择文章发布时间"></DatePicker>
                        </FormItem>
                        </Col>
                        <Col span="12">
                        <FormItem label="发布账户：">
                            <Select v-model="releaseUser" clearable placeholder="请选择">
                                <Option v-for="item in systemUserAllList" :value="item.loginName" :key="item.loginName">
                                    {{ item.loginName + "（" + item.realName + "）" }}
                                </Option>
                            </Select>
                        </FormItem>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div slot="search">
                <Button type="primary" icon="md-add" @click="addModel=true">添加</Button>
            </div>
            <div slot="btns">
                <Button type="info" icon="ios-search" @click="pageFindItem">查询</Button>
            </div>
            <div slot="paddingContent">
                <Table stripe :loading="tableLoading" :columns="columns1" :data="dataList"></Table>
            </div>
            <div slot="pager">
                <Page :total="pageTotal" @on-change="pageChange" @on-page-size-change="pageSizeChange" :page-size="pageSize" show-total show-elevator show-sizer/>
            </div>
        </MasterPage>
        <Modal v-model="addModel" title="新增文章" width="900" @on-cancel="cancelItem">
            <Form :label-width="90">
                <Row>
                    <Col span="10">
                    <FormItem  label="文章标题：">
                        <Input v-model="itemAdd.title"  placeholder="请输入标题" />
                    </FormItem>
                    <FormItem label="文章类别：">
                        <Select v-model="itemAdd.category" placeholder="请选择" filterable >
                            <Option v-for="item in articleTypeList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="封面图片：">
                        <Upload
                                ref="uploadImage"
                                multiple
                                type="drag"
                                :format="['jpg','jpeg','png']"
                                accept="image/*"
                                :before-upload="fileBefore"
                                :on-success="fileSuccess"
                                :on-error="fileError"
                                action="food/file/upload">
                            <div :style="{padding:'32px 0',backgroundImage: 'url(\'' + itemAdd.imageUrl + '\')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>单击或拖动图片以上传</p>
                            </div>
                        </Upload>
                    </FormItem>
                    </Col>
                    <Col span="14">
                    <FormItem  label="文章简介：">
                        <Input v-model="itemAdd.introduction" type="textarea" :rows="4" placeholder="请输入简介" />
                    </FormItem>
                    <FormItem label="文章标签：">
                        <Input v-model="Tag" :maxlength="10" style="width: 150px;" @on-enter="itemAdd.labels.push(Tag),Tag=''">
                        <Button style="width: 40px;padding: 0px" @click="itemAdd.labels.push(Tag),Tag=''" slot="append" icon="ios-add"></Button>
                        </Input>
                        <Tag v-for="(item,index) in itemAdd.labels" :key="item" :name="item"
                             closable @on-close="itemAdd.labels.splice(index, 1)">{{item}}</Tag>
                    </FormItem>
                    <Row>
                        <Col span="24">
                        <FormItem label="是否推广：">
                            <i-switch v-model="itemAdd.bannerTag">
                                <span slot="open">是</span>
                                <span slot="close">否</span>
                            </i-switch>
                        </FormItem>
                        <FormItem label="顺序：" v-if="itemAdd.bannerTag">
                            <InputNumber v-model="itemAdd.bannerIndex" :min="1" :max="6" style="width: 100px"/>
                        </FormItem>
                        </Col>
                    </Row>
                    </Col>
                </Row>
                <!--<div style="line-height: 50px">文章视频：</div>-->
                <!--<div style="display: flex;align-items: center">-->
                    <!--<video :src="itemAdd.videoUrl" style="height: 200px;margin: auto" controls="controls" v-if="itemAdd.videoUrl != null && itemAdd.videoUrl != ''"></video>-->
                <!--</div>-->
                <!--<Upload-->
                        <!--ref="uploadVideoAdd"-->
                        <!--multiple-->
                        <!--type="drag"-->
                        <!--:on-success="fileSuccess_update"-->
                        <!--:on-error="fileError"-->
                        <!--:before-upload="fileBeforeVideo"-->
                        <!--action="food/file/upload">-->
                    <!--<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>-->
                    <!--<p>单击或拖动视频以上传</p>-->
                <!--</Upload>-->
                <div style="line-height: 50px">文章内容：</div>
                <!-- <div id="editor"></div> -->
                <MyEditor @update:editorContent="contentUpdate" />
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="addLoading" @click="addItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="updateModel" title="修改文章" width="900" @on-cancel="cancelItem">
            <Form :label-width="90">
                <Row>
                    <Col span="10">
                    <FormItem  label="文章标题：">
                        <Input v-model="updateInfoItem.title"  placeholder="请输入标题" />
                    </FormItem>
                    <FormItem label="文章类别：">
                        <Select v-model="updateInfoItem.category" placeholder="请选择" filterable >
                            <Option v-for="item in articleTypeList" :value="item.id" :key="item.id">
                                {{ item.name }}
                            </Option>
                        </Select>
                    </FormItem>
                    <FormItem label="封面图片：">
                        <Upload
                                ref="uploadImageUpdate"
                                multiple
                                type="drag"
                                :format="['jpg','jpeg','png']"
                                accept="image/*"
                                :before-upload="fileBefore"
                                :on-success="fileSuccess_update"
                                :on-error="fileError"
                                action="food/file/upload">
                            <div :style="{padding:'32px 0',backgroundImage: 'url(' + updateInfoItem.imageUrl + ')',backgroundSize:'contain',backgroundRepeat:'no-repeat',backgroundPosition: 'center' }">
                                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                                <p>单击或拖动图片以上传</p>
                            </div>
                        </Upload>
                    </FormItem>
                    </Col>
                    <Col span="14">
                    <FormItem  label="文章简介：">
                        <Input v-model="updateInfoItem.introduction" type="textarea" :rows="4" placeholder="请输入简介" />
                    </FormItem>
                    <FormItem label="文章标签：">
                        <Input v-model="Tag" :maxlength="10" style="width: 150px;" @on-enter="updateInfoItem.labels.push(Tag),Tag=''">
                        <Button style="width: 40px;padding: 0px"
                                @click="updateInfoItem.labels.push(Tag),Tag=''" slot="append" icon="ios-add"></Button>
                        </Input>
                        <Tag v-for="(item,index) in updateInfoItem.labels" :key="item" :name="item"
                             closable @on-close="updateInfoItem.labels.splice(index, 1)">{{item}}</Tag>
                    </FormItem>
                    <Row>
                        <Col span="24">
                        <FormItem label="是否推广：">
                            <i-switch v-model="updateInfoItem.bannerTag">
                                <span slot="open">是</span>
                                <span slot="close">否</span>
                            </i-switch>
                        </FormItem>
                        <FormItem label="顺序：" v-if="updateInfoItem.bannerTag">
                            <InputNumber v-model="updateInfoItem.bannerIndex" :min="1" :max="6" style="width: 100px"/>
                        </FormItem>
                        </Col>
                    </Row>
                    </Col>
                </Row>
                <!--<div style="line-height: 50px">文章视频：</div>-->
                <!--<div style="display: flex;align-items: center">-->
                    <!--<video :src="updateInfoItem.videoUrl" style="height: 200px;margin: auto" controls="controls"-->
                           <!--v-if="updateInfoItem.videoUrl != null && updateInfoItem.videoUrl != ''"></video>-->
                <!--</div>-->
                <!--<Upload-->
                        <!--ref="uploadVideoUpdate"-->
                        <!--multiple-->
                        <!--type="drag"-->
                        <!--:on-success="videoSuccess_update"-->
                        <!--:on-error="fileError"-->
                        <!--:before-upload="fileBeforeVideo"-->
                        <!--action="food/file/upload">-->
                    <!--<Icon type="ios-cloud-upload" size="26" style="color: #3399ff"></Icon>-->
                    <!--<p>单击或拖动视频以上传</p>-->
                <!--</Upload>-->
                <div style="line-height: 50px">文章内容：</div>
                <!-- <div id="editorUpdate"></div> -->
                <MyEditor :editorContent="editArticleContent" @update:editorContent="contentUpdate" />
            </Form>
            <div slot="footer">
                <Button type="text" size="large" @click="cancelItem">取消</Button>
                <Button type="primary" size="large" :loading="updateLoading" @click="updateItem">确定</Button>
            </div>
        </Modal>
        <Modal v-model="infoModel" title="文章详情" width="750">
            <Form :label-width="90">
                <Row>
                    <Col span="12">
                    <div class="info_backgroup">
                        <div style="display: flex;align-items: center">
                            <video :src="infoItem.videoUrl" style="height: 200px;margin: auto" controls="controls"
                                   v-if="infoItem.videoUrl != null && infoItem.videoUrl != ''"></video>
                        </div>
                        <div v-html="infoItem.content" class="info_html"></div>
                    </div>
                    </Col>
                    <Col span="12">
                    <FormItem  label="文章标题：">
                        {{infoItem.title}}
                    </FormItem>
                    <FormItem  label="文章简介：">
                        {{infoItem.introduction}}
                    </FormItem>
                    <FormItem  label="封面图片：">
                        <img :src="`food/${infoItem.imageUrl}`" style="max-width: 100%;max-height: 150px;">
                    </FormItem>
                    <FormItem  label="文章标签：">
                        <Tag v-for="item in infoItem.label.split(',')"  :key="item" :name="item" >{{item}}</Tag>
                    </FormItem>
                    <FormItem label="是否推广：" >
                        {{infoItem.bannerTag ? '是' : '否'}}
                    </FormItem>
                    <FormItem label="顺序：" v-if="infoItem.bannerIndex" disabled>
                        {{infoItem.bannerIndex}}
                    </FormItem>
                    <FormItem  label="创建账户：">
                        {{infoItem.createUser}}
                    </FormItem>
                    <FormItem  label="创建时间：">
                        {{infoItem.createTime | dateTimeToString}}
                    </FormItem>
                    <FormItem  label="文章状态：">
                        {{statusInfo[infoItem.status]}}
                    </FormItem>
                    <div v-if="infoItem.status != 0">
                        <FormItem  label="发布账户：">
                            {{infoItem.releaseUser}}
                        </FormItem>
                        <FormItem  label="发布时间：">
                            {{infoItem.releaseTime | dateTimeToString}}
                        </FormItem>
                    </div>
                    </Col>
                </Row>
            </Form>
        </Modal>
    </section>
</template>

<script>
    import MasterPage from '@/components/Master'
    import MyEditor  from '@/components/MyEditor'
    var E = require('wangeditor')
    import {baseURL} from '../../json/common'
    export default {
        components:{
            MasterPage,
            MyEditor
        },
        data(){
            return{
                isBanner: false,
                bannerIndex: 1,
                columns1: [
                    {
                        type: 'index',
                        width: 80,
                        align: 'center'
                    },
                    {
                        title: '文章标题',
                        key: 'title',
                        tooltip: true,
                        align: 'center',
                    },
                    {
                        title: '文章简介',
                        align: 'center',
                        tooltip: true,
                        ellipsis: true,
                        render: (h, params) => {
                            return h('span', this.dataList[params.index].introduction)
                        }
                    },
                    {
                        title: '状态',
                        align: 'center',
                        render: (h, params) => {
                            if (this.dataList[params.index].status == 0){
                                return h('span', '未发布')
                            }else if(this.dataList[params.index].status == 1){
                                return h('span', '已发布')
                            }else if(this.dataList[params.index].status == 2){
                                return h('span', '已撤回')
                            }
                        }
                    },
                    {
                        title: '操作',
                        align: 'center',
                        minWidth:300,
                        render: (h, params) => {
                            let Buttons = [
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'ios-list-box',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.infoItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '详情'),
                                h('Button', {
                                    props: {
                                        type: 'primary',
                                        icon:'md-create',
                                        label:"small",
                                    },
                                    style: {
                                        marginRight: '5px'
                                    },
                                    on: {
                                        click: () => {
                                            this.updateItem_modal(this.dataList[params.index])
                                        }
                                    }
                                }, '编辑')
                            ]
                            if (this.dataList[params.index].status == 0){
//                                Buttons.push(
//                                    h('Button', {
//                                        props: {
//                                            type: 'primary',
//                                            icon:'md-create',
//                                            label:"small",
//                                        },
//                                        style: {
//                                            marginRight: '5px'
//                                        },
//                                        on: {
//                                            click: () => {
//                                                this.updateItem_modal(this.dataList[params.index])
//                                            }
//                                        }
//                                    }, '编辑')
//                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'error',
                                            icon:'md-trash',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '删除')
                                )
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'success',
                                            icon:'md-unlock',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.releaseItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '发布')
                                )
                            }else if (this.dataList[params.index].status == 1) {
                                Buttons.push(
                                    h('Button', {
                                        props: {
                                            type: 'warning',
                                            icon:'md-log-out',
                                            label:"small",
                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.recallItem_modal(this.dataList[params.index])
                                            }
                                        }
                                    }, '撤回')
                                )
                            }
                            return h("div",Buttons)
                        }
                    }
                ],
                dataList: [],
                tableLoading:false,
                systemUserAllList:[],
                title:'',
                createTime:[],
                createUser:'',
                releaseTime:[],
                releaseUser:'',
                statusList:'0',
                category: null,
                editor:'',
                editorUpdate:'',
                statusInfo:["未发布","已发布","已撤回"],
                addModel:false,
                addLoading:false,
                updateModel:false,
                updateLoading:false,
                infoModel:false,
                pageNum:1,
                pageSize:20,
                pageTotal:0,
                infoItem:{label:''},
                updateInfoItem:{label:''},
                itemAdd:{
                    id:'',
                    title:'',
                    introduction:'',
                    imageUrl:'',
                    content:'',
                    label:'',
                    labels:[],
                    type: '饮食',
                    videoUrl: '',
                    bannerTag: false,
                    bannerIndex: 1
                },
                Tag:'',
                type: '饮食',
                baseURL:baseURL,
                addArticleContent: '',
                editArticleContent: '',
                articleTypeList: [],
            }
        },
        created(){
            this.pageAllSystemUser()
            this.pageFindItem()
            this.getAllArticleType()
        },
        mounted(){
            // let editor = new E('#editor')
            // editor.customConfig.uploadImgShowBase64 = true
            // let menus = [
            //     'head',  // 标题
            //     'bold',  // 粗体
            //     'fontSize',  // 字号
            //     'fontName',  // 字体
            //     'italic',  // 斜体
            //     'underline',  // 下划线
            //     'strikeThrough',  // 删除线
            //     'foreColor',  // 文字颜色
            //     'backColor',  // 背景颜色
            //     'list',  // 列表
            //     'justify',  // 对齐方式
            //     'quote',  // 引用
            //     'emoticon',  // 表情
            //     'image',  // 插入图片
            //     'table',  // 表格
            //     'undo',  // 撤销
            //     'redo'  // 重复
            // ]
            // editor.customConfig.uploadImgShowBase64 = true
            // editor.customConfig.menus = menus
            // editor.customConfig.uploadImgMaxSize = 64 * 1024
            // editor.customConfig.uploadImgServer = 'food/file/upload'
            // editor.customConfig.uploadFileName = 'file'
            // editor.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // editor.create()
            // this.editor = editor

            // let editorUpdate = new E('#editorUpdate')
            // editorUpdate.customConfig.uploadImgShowBase64 = true
            // editorUpdate.customConfig.menus = menus
            // editorUpdate.customConfig.uploadImgMaxSize = 64 * 1024
            // editorUpdate.customConfig.uploadImgServer = 'food/file/upload'
            // editorUpdate.customConfig.uploadFileName = 'file'
            // editorUpdate.customConfig.uploadImgHooks = {
            //     customInsert: (insertImg, result, editor) => {
            //         insertImg(this.baseURL + result.data.replace(/\\/g,"/"))
            //     }
            // }
            // editorUpdate.create()
            // this.editorUpdate = editorUpdate
        },
        methods:{
            contentUpdate (content) {
              if (this.addModel) {
                this.addArticleContent = content
              } else {
                this.editArticleContent = content
              }
            },
            updateArticleBanner(item){
                this.$http.post('articles/updateBanner',{
                    articleId:item.id,
                    bannerTag:item.bannerTag,
                    bannerIndex: item.bannerIndex
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        console.log('aaaaaa', msg)
                    }else {
                        this.$Notice.error({title:'编辑文章失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            fileBefore(file){
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
                if (file.type.substring(0,file.type.indexOf("/")).toLowerCase() != 'image' ) {
                    this.$Message.warning('只能上传图片文件');
                    return false
                }
                if (file.size > 1048576) {
                    this.$Message.warning('图片大小请勿超过1M');
                    return false
                }
                return true
            },
            fileBeforeVideo(file){
                this.$refs.uploadVideoAdd.clearFiles()
                this.$refs.uploadVideoUpdate.clearFiles()

            },
            fileSuccess(response){
                this.$Notice.success({title:'图片上传成功'});
                this.itemAdd.imageUrl = response.data.replace(/\\/g,"/")
            },
            fileSuccess_update(response){
                this.$Notice.success({title:'图片上传成功'});
                this.updateInfoItem.imageUrl =response.data.replace(/\\/g,"/")
            },
            videoSuccess(response){
                this.$Notice.success({title:'文件上传成功'});
                this.itemAdd.videoUrl = response.data.replace(/\\/g,"/")
            },
            videoSuccess_update(response){
                this.$Notice.success({title:'文件上传成功'});
                this.updateInfoItem.videoUrl =response.data.replace(/\\/g,"/")
            },
            fileError(error){
                this.$Notice.error({title:'文件上传失败',desc: error.message});
            },
            pageChange(value){
                this.pageNum = value
                this.pageFindItem()
            },
            pageSizeChange(value){
                this.pageSize = value
                this.pageFindItem()
            },
            pageAllSystemUser(){
                this.$http.post('systemUser/list',{
                    pageSize:0,
                    pageNum:0,
                }).then(function (res) {
                    let msg = res.body
                    if (msg.success) {
                        this.systemUserAllList = msg.data.list
                    }else {
                        this.$Notice.error({title:'后台账户查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            getAllArticleType() {
              this.$http.post('articleType/list',{
                    type: this.type,
                    isDeleted: false,
                    pageSize: 0,
                    pageNum: 0,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.articleTypeList = msg.data.list
                    }else {
                        this.$Notice.error({title:'文章类别查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.myError(res.body)
                })
            },
            pageFindItem(){
                this.$Message.loading('正在加载中。。。')
                this.tableLoading = true
                this.$http.post('articles/list',{
                    title:this.title,
                    createStartTime:this.createTime[0] == undefined || this.createTime[0] == "" ? new Date(undefined):this.createTime[0]+"",
                    createEndTime:this.createTime[1] == undefined || this.createTime[1] == "" ? new Date(undefined):this.createTime[1]+"",
                    createUser:this.createUser == undefined ? "":this.createUser,
                    releaseStartTime:this.releaseTime[0] == undefined || this.releaseTime[0] == "" ? new Date(undefined):this.releaseTime[0]+"",
                    releaseStartTime:this.releaseTime[1] == undefined || this.releaseTime[1] == "" ? new Date(undefined):this.releaseTime[1]+"",
                    releaseUser:this.releaseUser == undefined ? "":this.releaseUser,
                    statusList:this.statusList,
                    category: this.category == undefined ? null : this.category,
                    pageSize:this.pageSize,
                    type: '饮食',
                    currentPage:this.pageNum,
                }).then(function (res) {
                    this.tableLoading = false
                    let msg = res.body
                    if (msg.success) {
                        this.dataList = msg.data.list
                        this.pageTotal = msg.data.total
                    }else {
                        this.$Notice.error({title:'文章列表查询失败',desc: msg.message});
                    }
                },function (res) {
                    this.tableLoading = false
                    this.myError(res.body)
                })
            },
            addItem(){
                // this.itemAdd.content = this.editor.txt.html();
                this.itemAdd.content = this.addArticleContent;
                if (this.itemAdd.title.length <= 0){
                    return this.$Message.warning('请输入文章标题');
                }
                if (this.itemAdd.category == null){
                    return this.$Message.warning('请选择文章分类');
                }
                if (this.itemAdd.introduction.length <= 0){
                    return this.$Message.warning('请输入文章简介');
                }
                if (this.itemAdd.imageUrl.length <= 0){
                    return this.$Message.warning('请上传文章封面图片');
                }
                if (this.itemAdd.content.length <= 0){
                    return this.$Message.warning('请输入文字内容');
                }
                this.itemAdd.label = this.itemAdd.labels.join(',')
                this.addLoading = true
                this.$http.post('articles/addArticle',
                    this.itemAdd,
                    {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        // 新增的文章返回文章实体后，调修改是否推广
                        this.updateArticleBanner(msg.data)
                        this.$Notice.success({title: '文章新增成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'文章新增失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            updateItem_modal(item){
                this.updateInfoItem = JSON.parse(JSON.stringify(item));
                if (this.updateInfoItem.label.split(',')[0] === ''){
                    this.updateInfoItem.labels = []
                } else {
                    this.updateInfoItem.labels = this.updateInfoItem.label.split(',')
                }
                // this.editorUpdate.txt.html(item.content)
                this.editArticleContent = item.content
                this.updateModel = true
            },
            updateItem(){
                // this.updateInfoItem.content = this.editorUpdate.txt.html();
                this.updateInfoItem.content = this.editArticleContent;
                if (this.updateInfoItem.title.length <= 0){
                    return this.$Message.warning('请输入文章标题');
                }
                if (this.updateInfoItem.category == null){
                    return this.$Message.warning('请选择文章分类');
                }
                if (this.updateInfoItem.introduction.length <= 0){
                    return this.$Message.warning('请输入文章简介');
                }
                if (this.updateInfoItem.imageUrl.length <= 0){
                    return this.$Message.warning('请上传文章封面图片');
                }
                if (this.updateInfoItem.content.length <= 0){
                    return this.$Message.warning('请输入文字内容');
                }
                this.updateInfoItem.label = this.updateInfoItem.labels.join(',')
                this.updateInfoItem['type'] = '饮食'
                this.updateLoading = true
                this.$http.post('articles/modifyArticle',
                    this.updateInfoItem,
                    {emulateJSON:false}).then(function (res) {
                    this.cancelItem()
                    let msg = res.body
                    if (msg.success) {
                        // 新增的文章返回文章实体后，调修改是否推广
                        console.log('result', msg)
                        this.updateArticleBanner(this.updateInfoItem)
                        this.$Notice.success({title: '文章修改成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'文章修改失败',desc: msg.message});
                    }
                },function (res) {
                    this.cancelItem()
                    this.myError(res.body)
                })
            },
            cancelItem(){
                this.addModel = this.addLoading = this.updateModel = this.updateLoading = this.infoModel = false
                this.itemAdd = {
                    id: '',
                    title: '',
                    videoUrl: '',
                    introduction: '',
                    imageUrl: '',
                    content: '',
                    label: '',
                    type: '饮食',
                    labels: [],
                }
                // this.editor.txt.clear()
                // this.editorUpdate.txt.clear()
                this.$refs.uploadImage.clearFiles()
                this.$refs.uploadImageUpdate.clearFiles()
            },
            infoItem_modal(item){
                this.infoItem = item
                this.infoModel = true
            },
            releaseItem_modal(item){
                this.$Modal.confirm({
                    title: '确认发布文章“'+ item.title + '”',
                    loading:true,
                    onOk: () => {
                        this.releaseItem(item);
                    }
                });
            },
            releaseItem(item){
                this.$http.post('articles/releaseArticle',{
                    articleId:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '文章发布成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'文章发布失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            deleteItem_modal(item){
                this.$Modal.confirm({
                    title: '确认删除文章“'+ item.title + '”',
                    content:"只有未发布的文章才允许删除",
                    loading:true,
                    onOk: () => {
                        this.deleteItem(item);
                    }
                });
            },
            deleteItem(item){
                this.$http.post('articles/deleteArticle',{
                    articleId:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '文章删除成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'文章删除失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
            recallItem_modal(item){
                this.$Modal.confirm({
                    title: '确认撤回文章“'+item.title + '”',
                    loading:true,
                    onOk: () => {
                        this.recallItem(item);
                    }
                });
            },
            recallItem(item){
                this.$http.post('articles/recallArticle',{
                    articleId:item.id,
                }).then(function (res) {
                    this.$Modal.remove()
                    let msg = res.body
                    if (msg.success) {
                        this.$Notice.success({title: '文章撤回成功'});
                        this.pageFindItem()
                    }else {
                        this.$Notice.error({title:'文章撤回失败',desc: msg.message});
                    }
                },function (res) {
                    this.$Modal.remove()
                    this.myError(res.body)
                })
            },
        }
    }
</script>

<style lang="postcss" scoped type="scss">
    .home-container{

    }

    .info_backgroup{
        background-image: url('../../assets/image/phone.png');
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        height: 630px;
        padding: 80px 45px 85px 50px;
    }

    .info_html{
        max-height:465px;
        overflow-y: scroll;
        overflow-x: hidden;
        padding-right: 5px;
    }

    .info_html >>> img{
        max-width: 100%;
    }

    .info_html::-webkit-scrollbar {
        width: 4px;
    }
    .info_html::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: rgba(0,0,0,0.2);
    }
    .info_html::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 0;
        background: rgba(0,0,0,0.1);
    }
</style>

